import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import CreateQR from '~/pages/CreateQR/CreateQR';
import ProtectedRoute from '~/routes/ProtectedRoute';

const CREATE_QR_ROUTES: RouteObject[] = [
  {
    path: PATH.QR.CREATE,
    element: (
      <ProtectedRoute>
        <CreateQR />
      </ProtectedRoute>
    ),
  },
];

export { CREATE_QR_ROUTES };
